import { useState, useCallback } from "react";
import EXIF from "exif-js";

// Convert DMS (Degrees, Minutes, Seconds) to Decimal Degrees
function convertDMSToDD(dmsArray, ref) {
  const degrees = dmsArray[0];
  const minutes = dmsArray[1];
  const seconds = dmsArray[2];
  let decimal = degrees + minutes / 60 + seconds / 3600;
  if (ref === "S" || ref === "W") {
    decimal = -decimal;
  }
  return decimal;
}

// Parse EXIF date string "YYYY:MM:DD HH:MM:SS" to ISO string
function parseExifDate(dateStr) {
  if (!dateStr) return null;
  const [date, time] = dateStr.split(" ");
  if (!date || !time) return null;
  return `${date.replace(/:/g, "-")}T${time}`;
}

// Standalone function — usable outside of React components
export function extractExifFromFile(file) {
  return new Promise((resolve) => {
    EXIF.getData(file, function () {
      const lat = EXIF.getTag(this, "GPSLatitude");
      const lon = EXIF.getTag(this, "GPSLongitude");
      const latRef = EXIF.getTag(this, "GPSLatitudeRef");
      const lonRef = EXIF.getTag(this, "GPSLongitudeRef");
      const make = EXIF.getTag(this, "Make") || "";
      const model = EXIF.getTag(this, "Model") || "";
      const dateTime = EXIF.getTag(this, "DateTimeOriginal") || null;

      resolve({
        hasGps: Boolean(lat && lon && latRef && lonRef),
        latitude: lat && latRef ? convertDMSToDD(lat, latRef) : null,
        longitude: lon && lonRef ? convertDMSToDD(lon, lonRef) : null,
        device: [make, model].filter(Boolean).join(" ") || "Unknown",
        originalTimestamp: dateTime,
        takenAt: parseExifDate(dateTime),
      });
    });
  });
}

export default function useExifExtract() {
  const [exifData, setExifData] = useState(null);
  const [loading, setLoading] = useState(false);

  const extractExif = useCallback((file) => {
    setLoading(true);
    return extractExifFromFile(file).then((result) => {
      setExifData(result);
      setLoading(false);
      return result;
    });
  }, []);

  const reset = useCallback(() => {
    setExifData(null);
    setLoading(false);
  }, []);

  return { exifData, loading, extractExif, reset };
}
